import React from 'react';
import { motion } from 'framer-motion';
import { Shovel, Cable, Zap, Hammer, ShieldAlert, ArrowRight } from 'lucide-react';
import { Button } from './ui/Button';
export function ServicesSection() {
  const services = [{
    title: 'Grondwerk',
    description: 'Ontgraven en dichten van kabeltracés, mantelbuizen persen, HDPE-glasvezelbuizen leggen en straatmeubilair plaatsen. Inclusief codering en markering van kabelnetwerken.',
    icon: Shovel,
    image: 'https://images.unsplash.com/photo-1590496793929-36417d3117de?w=600&q=80'
  }, {
    title: 'Kabelwerk',
    description: 'Laagspanningskabels (<1000V), middenspanning (6kV/10kV), signaal- en datakabels, glasvezel. Zowel bovengronds als ondergronds. Ook gespecialiseerd in het veilig verwijderen van oude bekabeling.',
    icon: Cable,
    image: 'https://images.unsplash.com/photo-1592731959622-0e7777119344?w=600&q=80'
  }, {
    title: 'Elektrowerk',
    description: 'Verlichting (industrie, utiliteit, openbare infra), aansluitwerk, groepenkasten, tijdelijke bouwvoorzieningen en het traceren van kabelstoringen.',
    icon: Zap,
    image: 'https://images.unsplash.com/photo-1621905251189-08b45d6a269e?w=600&q=80'
  }, {
    title: 'Montagewerk',
    description: 'Montage van kabelmanagementsystemen, ladderbanen, goten en prefab frames voor elektrokasten.',
    icon: Hammer,
    image: 'https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?w=600&q=80'
  }, {
    title: 'Brandwerende doorvoeringen',
    description: 'Conform Bouwbesluit en WBDBO-eisen. Veilig, gecertificeerd en duurzaam uitgevoerd.',
    icon: ShieldAlert,
    image: 'https://images.unsplash.com/photo-1581092160607-ee22621dd758?w=600&q=80'
  }];
  return <section className="py-24 bg-white" data-id="element-226">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-227">
        <div className="text-center mb-16" data-id="element-228">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-bold text-[#2E78B6] mb-4" data-id="element-229">
            Onze werkzaamheden
          </motion.h2>
          <div className="h-1.5 w-24 bg-[#F57C00] mx-auto rounded-full" data-id="element-230"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-231">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-xl overflow-hidden border border-gray-100 shadow-sm hover:shadow-xl transition-all duration-300 group hover:-translate-y-1 flex flex-col h-full" data-id="element-232">
              {/* Image Header */}
              <div className="h-48 overflow-hidden relative" data-id="element-233">
                <div className="absolute inset-0 bg-[#2E78B6]/10 group-hover:bg-transparent transition-colors z-10" data-id="element-234"></div>
                <img src={service.image} alt={service.title} className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500" data-id="element-235" />
                <div className="absolute bottom-4 left-4 z-20 w-12 h-12 bg-white rounded-lg flex items-center justify-center shadow-md" data-id="element-236">
                  <service.icon className="w-6 h-6 text-[#F57C00]" data-id="element-237" />
                </div>
              </div>

              <div className="p-8 flex-1 flex flex-col" data-id="element-238">
                <h3 className="text-xl font-bold text-[#2E78B6] mb-4 group-hover:text-[#F57C00] transition-colors" data-id="element-239">
                  {service.title}
                </h3>

                <p className="text-gray-600 leading-relaxed mb-6 flex-1" data-id="element-240">
                  {service.description}
                </p>

                <div className="flex items-center text-[#F57C00] font-medium text-sm group-hover:translate-x-2 transition-transform" data-id="element-241">
                  <span data-id="element-242">Meer info</span>
                  <ArrowRight className="w-4 h-4 ml-1" data-id="element-243" />
                </div>
              </div>
            </motion.div>)}

          {/* CTA Card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.5
        }} className="bg-gray-50 rounded-xl p-8 border-2 border-dashed border-gray-200 flex flex-col items-center justify-center text-center min-h-[400px]" data-id="element-244">
            <div className="w-16 h-16 bg-[#F57C00]/10 rounded-full flex items-center justify-center mb-6" data-id="element-245">
              <ArrowRight className="w-8 h-8 text-[#F57C00]" data-id="element-246" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-247">
              Meer weten over onze diensten?
            </h3>
            <p className="text-gray-600 mb-8 max-w-xs" data-id="element-248">
              Wij bieden maatwerk oplossingen voor elk project. Neem contact op
              voor de mogelijkheden.
            </p>
            <Button className="bg-[#F57C00] hover:bg-[#E56A00] text-white w-full" data-id="element-249">
              Bekijk alle mogelijkheden
            </Button>
          </motion.div>
        </div>
      </div>
    </section>;
}